import { render, staticRenderFns } from "./gameBind.vue?vue&type=template&id=28683f59&scoped=true&"
import script from "./gameBind.vue?vue&type=script&lang=js&"
export * from "./gameBind.vue?vue&type=script&lang=js&"
import style0 from "./gameBind.vue?vue&type=style&index=0&id=28683f59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28683f59",
  null
  
)

export default component.exports